import Helper from "../Helper";
import RangeDatePicker from "../datepicker/RangeDatePicker";
import Autocomplete from "./Autocomplete";
import RoomSettings from "./RoomSettings";
import ResponsiveModal from "../modals/ResponsiveModal";
import FullscreenModal from "../modals/FullscreenModal";
import SearchExtended from "./SearchExtended";

/**
 * This class represents search block.
 */
export default class Search {
    /**
     * Constructor.
     *
     * @param {String} searchName
     * @param {Boolean} useFullscreenModal
     */
    constructor(searchName, useFullscreenModal) {
        this.searchName = searchName;
        this.searchElement = $('[data-search="' + searchName + '"]');
        this.submitButton = $('[data-search-submit="' + searchName + '"]');
        this.searchExtend = new SearchExtended(this);

        if (useFullscreenModal) {
            this.respoModal = new FullscreenModal(
                searchName,
                0,
                0,
                584,
                this.hideRespoModalCallback.bind(this)
            );
        } else {
            this.respoModal = new ResponsiveModal(
                searchName,
                this.hideRespoModalCallback.bind(this),
                this.respoModalDragCallback.bind(this)
            );
        }

        this.searchActionsOrigin = this.searchElement.find(
            "[data-search-actions-origins]"
        );
        this.searchActionsRespo = this.respoModal.$modal.find(
            "[data-search-actions]"
        );

        if ($('[data-autocomplete="' + this.searchName + '"]').length > 0) {
            this.autocomplete = new Autocomplete(this.searchName, this);
            this.extended = false;
        }

        if (this.searchElement.length > 0) {
            this.datepicker = new RangeDatePicker(this.searchElement, this);
            this.roomSettings = new RoomSettings(this.searchName, this);
        }

        this.init();
    }

    searchAjax = function() {
        let viewDestination = $(
            '[data-view-destination="' +
            this.submitButton.data("ajaxViewDestination") +
            '"]'
        );

        $.ajax({
            url: this.submitButton.data("searchAjax"),
            method: this.submitButton.data("searchAjaxMethod"),
            data: {
                _token: $('meta[name="csrf-token"]').attr("content"),
                date: this.datepicker.getFormattedDate(),
                rooms: this.roomSettings.getRoomPlacement(),
            },
            dataType: "json",
            success: (returnData) => {
                $("[data-loader]").hide();
                viewDestination.html(returnData.view);

                switch (this.submitButton.data("searchSpecials")) {
                    case "rooms": {
                        setTimeout(() => {
                            let viewDestination =
                                '[data-view-destination="' +
                                this.submitButton.data("ajaxViewDestination") +
                                '"]';
                            Helper.initRoomsDependencies(viewDestination, returnData);
                            Helper.initFullscreenModals(viewDestination);
                            window.lazyloading.appendToObserver(viewDestination);
                        }, 500);
                        window.steppers["cart"].reset();
                        break;
                    }
                    default: {
                    }
                }
            },
        });
    }

    /**
     * This function will initialize search and all its dependencies.
     */
    init() {
        if (this.datepicker != undefined) this.datepicker.initDatepicker();

        if (
            this.submitButton.data("searchAjax") &&
            this.datepicker.datepicker !== undefined
        ) {
            this.submitButton.click((e) => {
                e.preventDefault();
                let viewDestination = $(
                    '[data-view-destination="' +
                    this.submitButton.data("ajaxViewDestination") +
                    '"]'
                );
                $("[data-loader]").show();
                viewDestination.html("");
                this.searchAjax();
            });
        } else if (this.autocomplete !== undefined) {
            this.submitButton.click((e) => {
                if (
                    !this.autocomplete.getSearchterm() ||
                    this.autocomplete.getSearchterm().length <= 2
                ) {
                    this.autocomplete.wrapper.addClass("error");
                    e.preventDefault();
                }
            });
        }

        if (
            typeof this.searchElement.data("searchOnLoad") !== "undefined" &&
            this.datepicker.datepicker !== undefined
        )
            this.submitButton.click();

        /**
         * When room settings values are changed, copy that change into preview
         */
        $("body").on(
            "DOMSubtreeModified",
            '[data-search="' + this.searchName + '"] [data-rooms-settings-values]',
            () => {
                this.updatePreview();
            }
        );

        if (this.autocomplete) {
            // Handle mobile landcape orientation resize
            this.respoKeepPreviewFullWidth();
            /**
             * Registering observers
             */
            window.windowResizeObserve.register(() => {
                // If search is extended and the window is tablet or lower and the scroll position is above 70
                // (search is not visible)
                if (
                    this.extended &&
                    Helper.isTabletOrLower() &&
                    $(window).scrollTop() > 70
                ) {
                    // Hide the search
                    $('[data-dim="search"]').click();
                }

                this.handleExtension(this.extended, false);

                this.respoKeepPreviewFullWidth();
            });

            // Handle elements before transition from extended search
            this.searchElement.on("transitionstart", () => {
                if (!this.extended && Helper.isMobileOrLower()) {
                    setTimeout(() => {
                        $("[data-extendable-preview]").removeClass("hidden-mvio");
                    }, 200);
                }
            });
            // Show/Hide elements after transition from extended search on mobile portrait orientation
            this.searchElement.on("transitionend", () => {
                if (!this.extended && Helper.isMobileOrLower()) {
                    $("[data-extendable-full]").addClass("hidden-mvio");
                    $("[data-search-extend-hide]").css("display", "");
                }
            });
        }
    }

    /**
     * This function is triggered after the search preview is extended to full search.
     * * Only does something if the search has preview (in other words has autocomplete)
     *
     * @param {Boolean} extended if the current state is extended or not
     * @param {Boolean} isNotBigSearch if it is a big search
     */
    handleExtension(extended, isNotBigSearch) {
        this.extended = extended;

        if (this.autocomplete) {
            let height = Helper.setBodyHeight();

            if (extended && isNotBigSearch) {
                if (Helper.isMobileOrLower()) {
                    window.bodyScroll.setHeight(window.innerHeight);
                } else {
                    window.bodyScroll.setHeight(height);
                }

                window.bodyScroll.disable();
            } else {
                if (!extended || Helper.isTabletOrHigher()) {
                    if (window.bodyScroll) {
                        window.bodyScroll.reset(true);
                    }
                }
            }
        }
    }

    /**
     * This function will set new date range to datepicker.
     *
     * @param {String} from in format DD-MM-YYYY
     * @param {String} to in format DD-MM-YYYY
     * @param {Function} callback that will be called after new dates were stored to a session
     */
    setDateRange(from, to, callback = undefined) {
        this.datepicker.setDateRange(from, to, callback);
    }

    /**
     * This function will set new date range to datepicker and will trigger new search.
     *
     * @param {String} from in format DD-MM-YYYY
     * @param {String} to in format DD-MM-YYYY
     */
    updateDateRange(from, to) {
        this.setDateRange(from, to, () => {
            window.location.reload();
        });
    }

    /**
     * Function called by datepicker on dates selection.
     */
    update() {
        this.updatePreview();
    }

    /**
     * This function will update search preview with its current data.
     */
    updatePreview() {
        if (this.autocomplete) {
            if (this.autocomplete.getSearchterm() != "") {
                $('[data-preview-term="' + this.searchName + '"]').html(
                    this.autocomplete.getSearchterm()
                );
            } else {
                $('[data-preview-term="' + this.searchName + '"]').html(
                    this.autocomplete.autocomplete.data("emptyString")
                );
            }

            let otherString = this.datepicker.getFormattedRange();
            if (otherString == "")
                otherString = this.searchElement.data("emptyDatesTranslation");
            otherString += " | ";
            let roomsSettingsString = this.searchElement
                .find("[data-rooms-settings-values]")
                .text();

            $('[data-preview-other="' + this.searchName + '"]').html(
                otherString + roomsSettingsString
            );
        }
    }

    /**
     * Will update other searches to have the same values.
     */
    updateOtherSearches() {
        Object.keys(window.searches).forEach((key) => {
            if (
                key != this.searchName &&
                window.searches[key].datepicker != undefined
            )
                window.searches[key].datepicker.cloneDateRange(
                    this.datepicker.datepicker
                );
        });
    }

    /**
     * On tablet and higher remove active of all actions.
     */
    deactivateAllActions() {
        if (Helper.isTabletOrHigher()) {
            this.searchElement
                .find("[data-respo-append]")
                .removeClass("active")
                .removeClass("error");
        }
    }

    /**
     * If the search action can be toggled (datepicker, autocomplete, etc.).
     *
     * @returns {boolean}
     */
    canToggleAction() {
        return (
            ($(window).width() > window.bigMobileBreakpoint &&
                !this.respoModal.isModalOpened()) ||
            ($(window).width() <= window.bigMobileBreakpoint &&
                this.respoModal.isModalOpened())
        );
    }

    /**
     * Checks if the respo search modal is opened.
     *
     * @returns {boolean}
     */
    isRespoModalOpened() {
        return this.respoModal.isModalOpened();
    }

    /**
     * Opens respo modal.
     *
     * @param {Element[]} searchActions
     * @param {Number} triggerIndex (which element should be clicked after modal open)
     */
    openRespoModal(searchActions, triggerIndex = 0) {
        $('html').css({'overflow-y': 'hidden'});

        this.respoModal.open(
            () => {
                this.swapActionsBetweenRespoAndOrigin(searchActions);
            },
            () => {
                this.respoModal.$modal
                    .find("[data-search-action]:eq(" + triggerIndex + ")")
                    .click();

                if (this.respoModal.$modal.find("input[data-autocomplete]").length) {
                    this.autocomplete.activateAndFocus();
                }
            }
        );
    }

    /**
     * Fires after the respo modal is hidden.
     */
    hideRespoModalCallback() {
        if (this.searchActionsRespo.find("[data-init-date]").length)
            this.datepicker.datepicker.hide();

        if (this.searchActionsRespo.find("[data-room-settings-wrapper]").length)
            this.roomSettings.close();

        if (this.searchActionsRespo.find("[data-autocomplete]").length) {
            this.autocomplete.documentClickClosing($("body"));
        }

        this.swapActionsBetweenRespoAndOrigin();
        this.updatePreview();
    }

    /**
     * Hides respo modal.
     */
    hideRespoModal() {
        this.respoModal.hide();
    }

    /**
     * This function will swap action elements between respo modal and origin search.
     * After swapping them to respo modal, in origin search, the mannequins that look same are created (for sliding).
     *
     * @param {Element[]} actions
     */
    swapActionsBetweenRespoAndOrigin(actions) {
        if (this.respoModal.isModalOpened() || actions == undefined) {
            // Swap from modal to origin
            let originActions = this.respoModal.$modal.find("[data-search-action]");
            let appendAfter = originActions.data("respoAppend");

            this.searchActionsOrigin.find("[data-is-mannequin]").remove();
            if (appendAfter != "") {
                this.searchActionsOrigin
                    .find('[data-search-action="' + appendAfter + '"]')
                    .last()
                    .after(originActions);
            } else {
                this.searchActionsOrigin.prepend(
                    this.respoModal.$modal.find("[data-search-action]")
                );
            }
        } else {
            // Swap from origin to modal
            actions.forEach((action) => {
                this.respoModal.$modal.find("[data-search-actions]").append(action);

                let actionClone = action.clone();
                let cloneAppendAfter = action.data("respoAppend");
                actionClone.attr("data-is-mannequin", "1");

                if (cloneAppendAfter != "") {
                    this.searchActionsOrigin
                        .find('[data-search-action="' + cloneAppendAfter + '"]')
                        .last()
                        .after(actionClone);
                } else {
                    this.searchActionsOrigin.prepend(actionClone);
                }
            });
        }
    }

    /**
     * Will keep search preview to 100% width.
     */
    respoKeepPreviewFullWidth() {
        if (Helper.isMobileOrLower()) {
            let width = window.innerWidth - 32; // 16 padding left/right
            let $stepBackElement = this.searchElement.closest("form").prev();
            if ($stepBackElement.length) width -= $stepBackElement.outerWidth();
            this.searchElement.css("width", width + "px");
        } else {
            this.searchElement.css("width", "");
        }
    }

    /**
     * This function triggers after respo modal dragging.
     *
     * @param {Number} newHeight height after drag
     */
    respoModalDragCallback(newHeight) {
        if (this.searchActionsRespo.find("[data-init-date]").length) {
            this.datepicker.fitRespoModal(undefined, true);
            return;
        }

        if (this.searchActionsRespo.find("[data-room-settings-wrapper]").length)
            this.roomSettings.resize();
    }

    /**
     * Function that calls change of select value in room settings
     *
     * @param {Element} e clicked select element
     */
    changeSelectValue(e) {
        this.roomSettings.changeSelectValue(e);
    }

    /**
     * Function that hides that picker
     */
    hideDatepicker() {
        if(this.datepicker !== undefined)
            this.datepicker.datepicker.hide();
    }
}
